import React from 'react';
import moment from 'moment';

import './index.scss';
import utils from '../../../lib/utils';
//const domain = utils.getCookie('domain');
const getClassBasedLabel = (auth)=>{
  if(auth.domain==='FITNESS'){
    return 'Enrollment ';
  }else{
    return 'Booking ';
  }
} 
const AppointmentHistory = ({ appointments,auth }) => {
  return (
    <div className="client-profile__card">
      <h1 className="client-profile__card__heading">{getClassBasedLabel(auth)} history</h1>
      <div className="client-profile__card__data">
        {appointments.map((appointment) => (
          <div className="history" key={appointment.id}>
            <h1>
              {appointment.service_name}
              {appointment.staff_name
                ? ` with ${appointment.staff_name}`
                : null}
            </h1>
            <p>{moment(appointment.times.date).format('MMM D, YYYY')}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AppointmentHistory;
